import React from 'react'
import '../styles/index.scss'
import ItemErrorPage from "./ItemColorSystemPage"

function ItemColorSystemContainer() {
    return (
        <div className="ItemColorSystemContainer">
            <ItemErrorPage/>
        </div>
    )
}

export default ItemColorSystemContainer